import { AddPolicyIndividualDTO } from '@core/pages/new-business-register/api'

export default class AddPolicyIndividual implements AddPolicyIndividualDTO {
  clientOid: string = undefined
  roles = []
  policyOid: string
  isOverwrite: boolean
  isMainOwner: boolean
}
